import { styled } from "@mui/material";
export const NewsContent = styled("div")(() => ({
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": "6" /* Número de linhas a exibir */,
}));
export const NewsTitle = styled("div")(() => ({
    overflow: "hidden",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
    "-webkit-line-clamp": "2" /* Número de linhas a exibir */,
}));
